export const api = {
  BULK_UPLOAD_QR: '/index.php?r=api/v1/operational/generate-qr/upload-excel',
  DOWNLOAD_RESULT_GENERATE_QR: '/index.php?r=api/v1/operational/generate-qr/download',
  DOWNLOAD_TEMPLATE_GENERATE_QR: '/index.php?r=api/v1/operational/generate-qr/download-template',
  LIST_HISTORY_GENERATE_QR: '/index.php?r=api/v1/operational/generate-qr/history',
};

export const failedUpload = (ctx, response) => {
  ctx.commit('setOnUpload', false);
  ctx.commit(
    'setSnackbar',
    {
      status: true,
      message: response?.data?.data?.message || 'Upload Failed !',
      icon: 'mdi-alert',
      color: 'red',
    },
    { root: true }
  );
  ctx.commit(
    'setInsertProgressGlobal',
    {
      absoluteBar: false,
      absoluteBarText: '',
    },
    { root: true }
  );
};

export const uploadConfig = (ctx, data) => ({
  method: 'post',
  url: `${process.env.VUE_APP_API_BASE_URL}/${api.BULK_UPLOAD_QR}`,
  headers: {
    'X-CSRF-TOKEN': JSON.parse(localStorage.getItem('logged_in_qram'))?.token,
    'X-Origin-Path': window.location.pathname
  },
  onUploadProgress(progressEvent) {
    ctx.commit(
      'setUploadProgress',
      parseInt(
        Math.round((progressEvent.loaded / progressEvent.total) * 100),
        10
      )
    );
  },
  data,
});


  